export default __webpack_public_path__ + "static/img/ss-2024.226b42e.jpg";